import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { CommonUser } from '../../types';
import { State } from '../../reducers';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Container } from 'semantic-ui-react';
import SettingRow from '../../components/SettingRow/SettingRow';

interface ViewSettingsAccountProps extends WithTranslation {
    user: CommonUser;
    dispatch: Dispatch<any>;
}

const mapStateToProps = (state: State) => (
    { user: state.authentication.user }
);

class ViewSettingsAccount extends React.Component<ViewSettingsAccountProps> {
    render() {
        if (!this.props.user) {
            return <Container style={{ minHeight: '100px' }} />;
        }
        return (
            <Container>
                <SettingRow title={this.props.t('account.subEmail')} content={this.props.user.email} />
                <SettingRow title={this.props.t('account.subPassword')} content="************" />
            </Container>
        );
    }
}

export default withTranslation('settings')(connect(mapStateToProps)(ViewSettingsAccount));
